// @ts-ignore issue with typing of history module
import { createBrowserHistory } from 'history';

export default createBrowserHistory();
